module.exports = __webpack_public_path__ + "img/small.82a81708.jpg";